@if (
  {
    row: columnData | async,
    adata: additionData | async,
  };
  as $
) {
  @if (ownershipLevel[$.row![$.adata.fetch_key]]) {
    <p>{{ ownershipLevel[$.row![$.adata.fetch_key]] }}</p>
  } @else {
    <p>-</p>
  }
}
